import React from "react";

import { normalizeColor } from "grommet/utils";
import styled, { useTheme } from "styled-components";
import { Box, Stack } from "grommet";

const TriangleBackground = styled(Box)`
  border-top: ${({ theme, height }) =>
    `${height}px solid ${theme.global.colors["neutral-3"]}`};
  border-right: ${({ width }) => `${width}px solid transparent`};
`;

export const LogoStack = ({ size }) => {
  let logoSize = size;
  let width = 360;
  let height = 180;
  if (logoSize === "small") {
    width = 160;
    height = 80;
  } else if (logoSize === "medium") {
    width = 260;
    height = 130;
  }
  return (
    <Stack anchor="top-left" style={{ position: "absolute", left: 0 }}>
      <TriangleBackground width={width} height={height} />
      <Box
        height={`${height / 2}px`}
        align="center"
        justify="center"
        margin={{ left: "medium" }}
      >
        <LogoFull size={size} />
      </Box>
    </Stack>
  );
};

export const LogoFull = ({ color = "white", size = "160px" }) => {
  const theme = useTheme();
  let logoSize = size;
  if (logoSize === "small") {
    logoSize = "80px";
  } else if (logoSize === "medium") {
    logoSize = "120px";
  } else if (logoSize === "large") {
    logoSize = "180px";
  }
  const iconColor = (plainColor = "#243c7d") =>
    normalizeColor(color === "plain" ? plainColor : color, theme);
  return (
    <svg viewBox="0 0 676.73 180.28" width={logoSize}>
      <path
        fill={iconColor()}
        d="M160.63 8.17H0l13.72 37h146.91a10.9 10.9 0 010 21.79H21.81l13.75 37h125.07a47.94 47.94 0 000-95.87z"
        transform="translate(0 -7.91)"
      />
      <path
        fill={iconColor()}
        d="M44.01 118.22l22.24 60.42h40.94l-22.24-60.42H44.01zM110.29 118.22l22.24 60.42h40.94l-22.24-60.42h-40.94z"
      />
      <path
        fill={iconColor()}
        d="M317.5 21.11h-13.86V9.89h40.51v11.22h-13.86v35H317.5zM349 7.91h12.54v17.36c2.31-3 5.6-5.68 10.68-5.68 7.59 0 12.15 5 12.15 13.13v23.36h-12.51V36.75c0-3.9-2.05-6-5-6s-5.27 2.11-5.27 6v19.33H349zM389.41 38.4v-.14c0-10.42 7.45-18.67 18-18.67 12.34 0 18 9 18 19.53 0 .79 0 1.72-.06 2.58h-23.87c1 3.89 3.83 5.87 7.72 5.87 3 0 5.34-1.12 7.92-3.63l6.93 5.74c-3.44 4.35-8.38 7.26-15.51 7.26-11.22 0-19.13-7.46-19.13-18.54zm24.28-3.1c-.46-4-2.77-6.47-6.21-6.47s-5.54 2.57-6.2 6.47zM306.21 75.52h21.84c7.06 0 11.94 1.85 15.05 5 2.7 2.63 4.09 6.2 4.09 10.75v.13c0 7.06-3.77 11.75-9.51 14.19l11 16.1h-14.76l-9.3-14H319v14h-12.8zm21.25 22.17c4.35 0 6.86-2.11 6.86-5.48v-.13c0-3.63-2.64-5.47-6.93-5.47H319v11.08zM350.81 104v-.13c0-10.42 7.46-18.67 18-18.67 12.34 0 18 9 18 19.53 0 .79 0 1.71-.07 2.57h-23.85c1 3.9 3.82 5.87 7.72 5.87 3 0 5.34-1.12 7.91-3.62l6.93 5.74c-3.43 4.35-8.38 7.25-15.5 7.25-11.22.02-19.14-7.43-19.14-18.54zm24.28-3.1c-.46-4-2.77-6.46-6.2-6.46s-5.54 2.57-6.2 6.46zM394.36 110.62V96.11h-4.23V86h4.23v-9h12.53v9h8.32v10.1h-8.32v12.07c0 2.51 1.12 3.56 3.43 3.56a11 11 0 004.75-1.18v9.83a17.91 17.91 0 01-8.71 2c-7.52.05-12-3.25-12-11.76zM420.61 73.54h13.07v9.24h-13.07zm.27 12.46h12.54v35.7h-12.54zM440.41 86h12.53v7.2c2.05-4.88 5.35-8 11.29-7.78v13.19h-1.06c-6.53 0-10.23 3.76-10.23 12v11.09h-12.53zM466.53 104v-.13c0-10.42 7.46-18.67 18-18.67 12.33 0 18 9 18 19.53 0 .79 0 1.71-.07 2.57h-23.85c1 3.9 3.83 5.87 7.72 5.87 3 0 5.34-1.12 7.91-3.62l6.93 5.74c-3.43 4.35-8.38 7.25-15.5 7.25-11.22.02-19.14-7.43-19.14-18.54zm24.28-3.1c-.46-4-2.77-6.46-6.2-6.46s-5.54 2.57-6.2 6.46zM507.9 86h12.54v4.88c2.31-3 5.61-5.67 10.62-5.67 4.75 0 8.38 2.11 10.29 5.81 3.1-3.57 6.73-5.81 11.94-5.81 7.59 0 12.21 4.75 12.21 13.06v23.43H553v-19.4c0-3.89-1.91-5.94-4.88-5.94s-5.14 2-5.14 5.94v19.4H530.4v-19.4c0-3.89-1.91-5.94-4.88-5.94s-5.08 2-5.08 5.94v19.4H507.9zM570.51 104v-.13c0-10.42 7.46-18.67 18-18.67 12.34 0 18 9 18 19.53 0 .79 0 1.71-.07 2.57h-23.85c1 3.9 3.82 5.87 7.72 5.87 3 0 5.34-1.12 7.91-3.62l6.93 5.74c-3.43 4.35-8.38 7.25-15.5 7.25-11.22.02-19.14-7.43-19.14-18.54zm24.28-3.1c-.46-4-2.77-6.46-6.2-6.46s-5.54 2.57-6.2 6.46zM611.88 86h12.53v5c2.31-3 5.61-5.81 10.69-5.81 7.59 0 12.14 5 12.14 13.13v23.36h-12.53v-19.31c0-3.89-2.05-6-5-6s-5.28 2.11-5.28 6v19.34h-12.55zM655.88 110.62V96.11h-4.22V86h4.22v-9h12.54v9h8.31v10.1h-8.31v12.07c0 2.51 1.12 3.56 3.43 3.56a11.07 11.07 0 004.75-1.18v9.83a17.91 17.91 0 01-8.71 2c-7.52.05-12.01-3.25-12.01-11.76zM317.5 152.36h-13.86v-11.21h40.51v11.21h-13.86v35H317.5zM346.72 151.64h12.54v7.19c2-4.88 5.34-8.05 11.28-7.79v13.2h-1.06c-6.53 0-10.22 3.76-10.22 12v11.08h-12.54zM371.53 177.11V177c0-7.39 5.61-11.21 14-11.21a27.48 27.48 0 018.57 1.38v-.59c0-3.7-2.31-5.81-7.12-5.81a25.18 25.18 0 00-9.83 2l-2.58-8.84a35.89 35.89 0 0114.43-2.82c6.4 0 10.76 1.52 13.6 4.35 2.7 2.64 3.82 6.34 3.82 11.35v20.52H394v-3.69a13.48 13.48 0 01-10.49 4.48c-6.77 0-11.98-3.89-11.98-11.01zm22.7-2.71v-1.65a13.15 13.15 0 00-4.89-.92c-3.63 0-5.74 1.78-5.74 4.42v.13c0 2.44 1.85 3.89 4.42 3.89 3.63 0 6.21-2.27 6.21-5.87zM411.38 169.65v-.13c0-10.1 7.85-18.61 19.13-18.61 7.33 0 12.21 3.17 15.24 8l-8.51 6.33c-1.71-2.38-3.63-3.76-6.66-3.76-4 0-7 3.56-7 7.92v.13c0 4.62 2.91 8.11 7.13 8.11 3 0 4.88-1.38 6.86-3.69L446 180c-3.3 4.88-8.05 8.18-15.9 8.18a18.42 18.42 0 01-18.72-18.53zM450.37 139.17h12.54v24.41l9.69-11.94h14.19L474.39 166l12.73 21.37h-13.79l-7.19-12.14-3.23 3.77v8.38h-12.54z"
        transform="translate(0 -7.91)"
      />
      <path
        fill={iconColor()}
        d="M486.72 169.65v-.13c0-10.43 7.46-18.67 18-18.67 12.34 0 18 9 18 19.53 0 .79 0 1.71-.07 2.57H498.8c1 3.89 3.82 5.87 7.72 5.87 3 0 5.34-1.12 7.91-3.63l6.93 5.74c-3.43 4.36-8.38 7.26-15.5 7.26-11.22 0-19.14-7.45-19.14-18.54zm24.28-3.1c-.46-4-2.77-6.47-6.2-6.47s-5.54 2.58-6.2 6.47zM528.09 151.64h12.54v7.19c2-4.88 5.34-8.05 11.28-7.79v13.2h-1.06c-6.53 0-10.22 3.76-10.22 12v11.08h-12.54z"
        transform="translate(0 -7.91)"
      />
      <path fill={iconColor("#3f4654")} d="M251.84.26h6.98v178.38h-6.98z" />
    </svg>
  );
};
